import {
  CheckIcon,
  ExclamationTriangleIcon,
  InfoCircleIcon,
  SvgComponent,
} from '../../assets';
import { theme } from '../../theme';
import { InfoPanelType } from './types';

export function getDefaultTitleIcon(type: InfoPanelType): SvgComponent {
  switch (type) {
    case 'important':
      return ExclamationTriangleIcon;
    case 'info':
      return InfoCircleIcon;
    case 'success':
      return CheckIcon;
    case 'subtle':
      return InfoCircleIcon;
  }
}

export function panelColor(
  type: InfoPanelType
):
  | (typeof theme.colors.system)[
      | 'systemRedLite'
      | 'systemBlueLite'
      | 'systemGreenLite']
  | (typeof theme.colors.neutrals.solidGrays)[8] {
  switch (type) {
    case 'important':
      return theme.colors.system.systemRedLite;
    case 'info':
      return theme.colors.system.systemBlueLite;
    case 'success':
      return theme.colors.system.systemGreenLite;
    case 'subtle':
      return theme.colors.neutrals.solidGrays[8];
  }
}

export function titleColor(
  type: InfoPanelType
): (typeof theme.colors.system)['systemRed' | 'systemBlue' | 'systemGreen'] {
  switch (type) {
    case 'important':
      return theme.colors.system.systemRed;
    case 'info':
      return theme.colors.system.systemBlue;
    case 'success':
      return theme.colors.system.systemGreen;
    case 'subtle':
      return theme.colors.primary.graysGray;
  }
}
